import { DatePicker as MantineDatePicker, DatePickerProps as MantineDatePickerProps } from "@mantine/dates";

export type DatePickerProps = MantineDatePickerProps

export const DatePicker = (props: DatePickerProps) => {
  return <MantineDatePicker {...props} />;
};
